import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-payinpage',
  templateUrl: './payinpage.component.html',
  styleUrls: ['./payinpage.component.sass']
})
export class PayinpageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
